import { Typography } from "antd";
import { PageLayout } from "components";
import { DataSets, SchemaModels } from "containers";
import { useEffect, useRef, useState } from "react";
import { useHistory, useParams } from "react-router-dom";

function usePreviousAction(value) {
    const ref = useRef();
    useEffect(() => {
        ref.current = value;
    });
    return ref.current;
}

const SchemaPage = (props) => {
    const history = useHistory();
    const { tenant, businessarea, schemaAction, schemaId } = useParams();
    const prevSchemaAction = usePreviousAction(schemaAction);
    const [showDataSets, setShowDataSets] = useState(false);
    const [selectedSchemaModelInfo, setSelectedSchemaModelInfo] = useState({ schemaModel: null, userBusinessArea: null });

    const onSchemaModelListLoaded = () => {
        setShowDataSets(true);
    };

    const onSchemaModelListUnLoaded = () => {
        setShowDataSets(false);
        setSelectedSchemaModelInfo({ schemaModel: null, userBusinessArea: null });
    };

    const onSchemaModelSelected = ({ schemaModel, userBusinessArea }) => {
        history.push(`#${schemaModel.name}`);
        setSelectedSchemaModelInfo({ schemaModel, userBusinessArea });
    };

    return (
        <PageLayout
            key={`${businessarea}_schema_page`}
            mainContent={({ setBreadcrumbNavigationItems }) => {
                return (
                    <div className="relative flex size-full flex-1 flex-col gap-4 overflow-auto">
                        <SchemaModels
                            key={`${businessarea}_${schemaAction || "default"}_schema_model`}
                            setBreadcrumbNavigationItems={setBreadcrumbNavigationItems}
                            tenant={tenant}
                            businessArea={businessarea.toLowerCase()}
                            action={schemaAction}
                            prevAction={prevSchemaAction}
                            schemaId={schemaId}
                            onSchemaModelListLoaded={onSchemaModelListLoaded}
                            onSchemaModelListUnLoaded={onSchemaModelListUnLoaded}
                            onSchemaModelSelected={onSchemaModelSelected}
                        ></SchemaModels>
                        {showDataSets && (
                            <DataSets
                                key={`${businessarea}_${(selectedSchemaModelInfo.schemaModel && selectedSchemaModelInfo.schemaModel.schemaId) || "default"}_schema_datasets`}
                                selectedSchemaModel={selectedSchemaModelInfo.schemaModel}
                                userBusinessArea={selectedSchemaModelInfo.userBusinessArea}
                                tenant={tenant}
                                businessArea={businessarea.toLowerCase()}
                            ></DataSets>
                        )}
                    </div>
                );
            }}
            helpContent={<Typography>We're working on this documentation.</Typography>}
        ></PageLayout>
    );
};

export default SchemaPage;
